module.exports = __webpack_public_path__ + "fonts/Sarabun-Bold.60bddd6b.ttf";